import { managerAssessmentService } from '@/api/cycle-evaluation-services/manager-assessment';
import { useTranscriptRecap } from '@/components/MeetingTranscript/useTranscriptRecap';
import { PostReviewMeetingQueryKey } from '@/constants/QueryKeys';

/** The AI recap of the transcript uploaded for a manager assessment, scoped to its cycle instance. */
export const useMeetingRecap = (
    cycleInstanceId: string | undefined,
    pendingCorrelationId?: string | null,
) =>
    useTranscriptRecap({
        subjectId: cycleInstanceId,
        pendingCorrelationId,
        transcriptQueryKey: (id) => [PostReviewMeetingQueryKey.MEETING_TRANSCRIPT, id],
        requestRecap: (id, correlationId) =>
            managerAssessmentService.generateRecap({ cycleInstanceId: id, correlationId }),
    });
